import { BaseDto } from '@/shared/dtos/base-dto';

export class mensajes_chat extends BaseDto {
    public mensaje !: string;
    public fecha!:Date;
    public id_incidencia !: number;
 } 
